import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "card shadow-sm mb-4" }
const _hoisted_2 = { class: "card-content" }
const _hoisted_3 = {
  key: 0,
  class: "row m-auto"
}
const _hoisted_4 = { class: "col-md-12 px-5 py-2 financial-calendar" }
const _hoisted_5 = { class: "row pt-4" }
const _hoisted_6 = { class: "col-sm-12 col-md-8" }
const _hoisted_7 = ["value"]
const _hoisted_8 = ["value"]
const _hoisted_9 = { class: "col-sm-12 col-md-4" }
const _hoisted_10 = {
  key: 1,
  class: "loading-area"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[6] || (_cache[6] = _createElementVNode("div", { class: "card-header text-white bg-secondary fw-bold" }, "Filters", -1)),
    _createElementVNode("div", _hoisted_2, [
      (!_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _withDirectives(_createElementVNode("select", {
                    class: "border-0 text-secondary me-2 mb-2",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.partner_id) = $event))
                  }, [
                    _cache[3] || (_cache[3] = _createElementVNode("option", { value: null }, "All Courses", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.partners, (partner) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: partner.id,
                        value: partner.id
                      }, _toDisplayString(partner.short_name), 9, _hoisted_7))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _ctx.partner_id]
                  ]),
                  _withDirectives(_createElementVNode("select", {
                    class: "border-0 text-secondary me-2",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.scenario_id) = $event))
                  }, [
                    _cache[4] || (_cache[4] = _createElementVNode("option", { value: null }, "All Scenarios", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.scenarios, (scenario) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: scenario.id,
                        value: scenario.id
                      }, _toDisplayString(scenario.patient_name), 9, _hoisted_8))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _ctx.scenario_id]
                  ])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("button", {
                    class: "btn btn-primary btn-xs mb-1 float-end",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.updateDashboard()))
                  }, "Update")
                ])
              ]),
              _cache[5] || (_cache[5] = _createElementVNode("hr", null, null, -1))
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createVNode(_component_loading, {
              active: _ctx.loading,
              "is-full-page": true
            }, null, 8, ["active"])
          ]))
    ])
  ]))
}